export default __webpack_public_path__ + "static/media/upload-profile.29e69ded.svg";